/**
 * /tenants/$slug/security/logon-certificates/$forest/trust — one forest's trust-distribution packet.
 *
 * ── WHY THIS IS A ROUTE AND NOT A DIALOG ────────────────────────────────────
 *
 * ONE FOREST AT A TIME, BY ROUTE PARAMETER. The mistake this whole area guards against is publishing one
 * forest's issuing authority into another forest's NTAuth, and a page showing several forests' certificates
 * side by side is an invitation to copy from the wrong card. The parameter makes it impossible to be looking
 * at two at once.
 *
 * A route is also LINKABLE and bookmarkable, which matters because the workflow is "send this to the AD
 * team" — and it survives the tenant admin closing the tab halfway through a change window.
 *
 * The loader swallows a rejection for the same reason the readiness route does: an operator whose read
 * failed belongs on the page with its banner, not on the router's error screen with no way back.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchTrustPacket } from "@/features/logon-certificates/queries";
import { TrustDistributionPage } from "@/features/logon-certificates/pages/trust-distribution-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/security/logon-certificates/$forest/trust",
)({
  loader: ({ context, params }) =>
    context.queryClient
      .ensureQueryData({
        queryKey: queryKeys.logonCertificates.trust(context.tenant.id, params.forest),
        queryFn: () => fetchTrustPacket(context.tenant.id, params.forest),
      })
      .catch(() => undefined),
  component: TrustDistributionPage,
});
